// Shared building blocks for the editorial page layout. No data access here, so any screen can use them.

const unsplash = (id, ixid) => `https://images.unsplash.com/photo-${id}?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=${ixid}&ixlib=rb-4.1.0&q=80&w=1080`;

export const photos = {
  homeHero: { src: unsplash('1648475238180-7333e740615d', 'M3w4NDM0ODN8MHwxfHJhbmRvbXx8fHx8fHx8fDE3OTEwNjQ0MjF8'), alt: 'A bright living room with a wooden armchair and a large potted plant' },
  homePortal: { src: unsplash('1642455680602-7b4ddf7560a4', 'M3w4NDM0ODN8MHwxfHJhbmRvbXx8fHx8fHx8fDE3OTEwNjQ1MTJ8'), alt: 'A light and airy home interior with cushions, a lamp and pictures on the wall' },
  resident: { src: unsplash('1527774436903-af05f4d201c0', 'M3w4NDM0ODN8MHwxfHJhbmRvbXx8fHx8fHx8fDE3OTEwNjQzNjV8'), alt: 'House plants on a sunny windowsill' },
  commercial: { src: unsplash('1632829882891-5047ccc421bc', 'M3w4NDM0ODN8MHwxfHJhbmRvbXx8fHx8fHx8fDE3OTEwNjQzODl8'), alt: 'A freshly finished living room with a sofa, framed prints and a lamp' },
  homeServices: { src: unsplash('1722942723511-11c7603d003c', 'M3w4NDM0ODN8MHwxfHJhbmRvbXx8fHx8fHx8fDE3OTEwNjQzNjZ8'), alt: 'A calm bedroom with a made bed and soft lighting' },
  homeJobs: { src: unsplash('1713514374038-656f7bbde9db', 'M3w4NDM0ODN8MHwxfHJhbmRvbXx8fHx8fHx8fDE3OTEwNjQzNjZ8'), alt: 'A bright kitchen with white cupboards and a large window' },
  housingTeams: { src: unsplash('1700419595003-cf7449b63408', 'M3w4NDM0ODN8MHwxfHJhbmRvbXx8fHx8fHx8fDE3OTEwNjQ1MTJ8'), alt: 'A row of painted terraced houses' },
  signIn: { src: unsplash('1774156720905-11b4f15b284d', 'M3w4NDM0ODN8MHwxfHJhbmRvbXx8fHx8fHx8fDE3OTEwNjQzNjZ8'), alt: 'A street of red brick houses on a sunny day' },
  signUp: { src: unsplash('1771287491132-4954b32210d6', 'M3w4NDM0ODN8MHwxfHJhbmRvbXx8fHx8fHx8fDE3OTEwNjQzNjZ8'), alt: 'A bedroom with large windows looking out over the city' },
  accountGate: { src: unsplash('1772476361154-e894ba10d757', 'M3w4NDM0ODN8MHwxfHJhbmRvbXx8fHx8fHx8fDE3OTEwNjQ0MjF8'), alt: 'A welcoming home interior' },
};

export function Photo({ photo, className = '', eager = false }) {
  return <img className={`rs-photo ${className}`} src={photo.src} alt={photo.alt} loading={eager ? 'eager' : 'lazy'} decoding="async"/>;
}

/** Kicker, page title and introduction used at the top of most pages. */
export function PageHead({ kicker, title, lede, children, className = '' }) {
  return <header className={`rs-page-head ${className}`}>
    {kicker && <p className="rs-kicker">{kicker}</p>}
    <h1 className="rs-title">{title}</h1>
    {lede && <p className="rs-lede">{lede}</p>}
    {children}
  </header>;
}

const iconPaths = {
  sunMoon: <><path d="M12 2v2"/><path d="M13 8.129A4 4 0 0 1 15.873 11"/><path d="m19 5-1.256 1.256"/><path d="M20 12h2"/><path d="M9 8a5 5 0 1 0 7 7 7 7 0 1 1-7-7"/></>,
  search: <><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></>,
  sliders: <><path d="M21 4h-7M10 4H3M21 12h-9M8 12H3M21 20h-5M12 20H3M14 2v4M8 10v4M16 18v4"/></>,
  arrowLeft: <><path d="m12 19-7-7 7-7"/><path d="M19 12H5"/></>,
  arrowRight: <><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></>,
  external: <><path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/></>,
  file: <><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4"/><path d="M10 9H8M16 13H8M16 17H8"/></>,
  mailWarning: <><path d="M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/><path d="M20 14v4"/><path d="M20 22v.01"/></>,
  shieldCheck: <><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/><path d="m9 12 2 2 4-4"/></>,
  menu: <><path d="M4 6h16M4 12h16M4 18h16"/></>,
  close: <><path d="M18 6 6 18M6 6l12 12"/></>,
  bookmark: <path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"/>,
};

export function LineIcon({ name, size = 20 }) {
  return <svg className="rs-icon" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">{iconPaths[name]}</svg>;
}

/** A centred status message, used for incomplete links and signed-out states. */
export function StatusState({ icon, kicker, title, children, wide = false }) {
  return <div className={`rs-state ${wide ? 'is-wide' : ''}`}>
    <span className="rs-state-icon"><LineIcon name={icon} size={40}/></span>
    <p className="rs-kicker">{kicker}</p>
    <h1 className="rs-state-title">{title}</h1>
    {children}
  </div>;
}
